'use client';

import type { PropertyDetailListing } from '@/src/components/features/property/types';
import { useListingCTAs } from '@/src/components/features/property/hooks/useListingCTAs';
import { ListingCTAButton } from '@/src/components/features/property/ListingCTAButton';

type Props = {
  listing: PropertyDetailListing;
  testIdSuffix?: string;
};

const FOOTER_CTA_TRIGGER_LOCATION = 'home_details_halo';
const FOOTER_CTA_TRIGGER_OBJECT = 'home_details_component|modal_contact_form';

/**
 * Mobile sticky footer CTAs — Contact / Tour / Apply buttons rendered
 * inside ListingPage's `spokeFooterCTAs` slot on mobile.
 */
export const SpokeFooterCTAs = ({ listing, testIdSuffix }: Props) => {
  const { ctas, overlays } = useListingCTAs(listing, FOOTER_CTA_TRIGGER_LOCATION, FOOTER_CTA_TRIGGER_OBJECT);
  const getTestId = (testId: string) => (testIdSuffix ? `${testId}-${testIdSuffix}` : testId);

  if (ctas.length === 0) return null;

  return (
    <>
      {ctas.map((cta) => (
        <ListingCTAButton
          key={cta.id}
          cta={cta}
          data-testid={getTestId(`button-${cta.id === 'contact' ? 'message' : cta.id}`)}
          fluid
        />
      ))}
      {overlays}
    </>
  );
};
